import { BodySmall, theme } from '@arnold/common';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';

export const FullWidthButton = styled(Button)`
  width: 100%;
`;

export const RoundLogo = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${theme.colors.backgroundBasic.default};
  margin: 0 auto ${theme.spacing.f};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ColoredBodySmall = styled(BodySmall)`
  color: ${theme.colors.text.secondary};
  text-align: center;
`;
